"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListingDetails = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactCollapsible = _interopRequireDefault(require("react-collapsible"));

var _reactRedux = require("react-redux");

var _find2 = _interopRequireDefault(require("lodash/find"));

var _uniq2 = _interopRequireDefault(require("lodash/uniq"));

var _nuiIntl = require("@concur/nui-intl");

var _reactRouter = require("react-router");

var _Carousel = _interopRequireDefault(require("./Carousel"));

var _LogoLinksAndDesc = _interopRequireDefault(require("./LogoLinksAndDesc"));

var _termsModule = require("../terms/termsModule");

var _terms = _interopRequireDefault(require("../terms"));

var _EnrollModal = _interopRequireDefault(require("./EnrollModal"));

var _UnenrollModal = _interopRequireDefault(require("./UnenrollModal"));

var _DisconnectModal = _interopRequireDefault(require("./DisconnectModal"));

var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));

var _trackClick = require("../HOCs/trackClick");

var _utils = require("../utils");

var _offeringTypes = _interopRequireDefault(require("../config/offeringTypes"));

var _regions = _interopRequireDefault(require("../config/regions"));

var _withAppContext = require("../HOCs/withAppContext");

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/listingDetails.css") : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ListingDetails =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListingDetails, _React$Component);

  function ListingDetails() {
    var _this;

    _classCallCheck(this, ListingDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListingDetails).call(this));
    _this.state = {
      detailsExpanded: false,
      regionIsDisplayed: false
    };
    _this._toggleDetails = _this._toggleDetails.bind(_assertThisInitialized(_this));
    _this._toggleRegionDisplay = _this._toggleRegionDisplay.bind(_assertThisInitialized(_this));
    _this.launchTandCinfoOnly = _this.launchTandCinfoOnly.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ListingDetails, [{
    key: "_toggleDetails",
    value: function _toggleDetails() {
      // if this ever needs to be re-used or gets ugly, we can consider:
      // https://github.com/craigambrose/react-more/blob/master/lib/index.js
      this.setState({
        detailsExpanded: !this.state.detailsExpanded
      });
    }
  }, {
    key: "launchTandCinfoOnly",
    value: function launchTandCinfoOnly() {
      this.props.launchTaCModal({
        tAndCLinkClicked: true,
        ID: this.props.listing.ID,
        v1ListingId: this.props.listing.core.v1ID
      });
    }
  }, {
    key: "renderDisabledWarning",
    value: function renderDisabledWarning() {
      var isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var hasOfferings = arguments.length > 1 ? arguments[1] : undefined;
      var isAdminListing = arguments.length > 2 ? arguments[2] : undefined;

      if (isDisabled) {
        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ListingDisabledByCompany",
          className: "cnqr-alert cnqr-alert-warning disabled-warning"
        });
      }

      if (!hasOfferings && !isAdminListing) {
        return _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ListingNotCompatibleWithOfferings",
          className: "cnqr-alert cnqr-alert-warning disabled-warning"
        });
      }

      return null;
    }
  }, {
    key: "renderOfferings",
    value: function renderOfferings() {
      var offerings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return _react.default.createElement("ul", null, offerings.map(function (offering) {
        return _react.default.createElement("li", {
          key: offering
        }, _react.default.createElement("p", null, _offeringTypes.default[offering]));
      }));
    }
  }, {
    key: "_toggleRegionDisplay",
    value: function _toggleRegionDisplay() {
      this.setState({
        regionIsDisplayed: !this.state.regionIsDisplayed
      });
    }
  }, {
    key: "renderRegions",
    value: function renderRegions(regions) {
      var _this2 = this;

      var localizedRegionsAndCountries;

      if (this.props.localizedRegions && this.props.localizedCountries) {
        localizedRegionsAndCountries = Object.entries(regions).map(function (region) {
          var localizedRegionName = (0, _find2.default)(_this2.props.localizedRegions, function (localizedRegion) {
            return localizedRegion.code === _regions.default[region[0]];
          });
          var localizedCountries = [];
          region[1].map(function (countryCode) {
            var localizedCountryName = (0, _find2.default)(_this2.props.localizedCountries, function (localizedCountry) {
              return localizedCountry.code === countryCode;
            });
            return localizedCountries.push(localizedCountryName.description);
          });
          return {
            region: localizedRegionName.description,
            countries: localizedCountries
          };
        });
      }

      var output;

      if (localizedRegionsAndCountries) {
        output = localizedRegionsAndCountries.filter(function (region) {
          return region.countries.length !== 0;
        }).map(function (i) {
          return _react.default.createElement("div", {
            onClick: _this2._toggleRegionDisplay,
            key: i.region
          }, _react.default.createElement(_reactCollapsible.default, {
            key: i.region,
            trigger: _react.default.createElement("div", null, _react.default.createElement("a", {
              className: "region-list-element",
              tabIndex: "0"
            }, i.region), _react.default.createElement("span", {
              id: "country-list",
              className: "".concat(_this2.state.regionIsDisplayed ? 'region-opened' : 'region-closed', " icon-arrow-1-n icon-size-sm")
            })),
            classParentString: "regions-collapse"
          }, _react.default.createElement("ul", null, Object.values((0, _uniq2.default)(i.countries)).map(function (country) {
            return _react.default.createElement("li", {
              key: country
            }, _react.default.createElement("p", null, country));
          }))));
        });
      }

      return _react.default.createElement("ul", null, output);
    }
  }, {
    key: "renderBackToAppCenter",
    value: function renderBackToAppCenter(ID, listingName) {
      var _this3 = this;

      return _react.default.createElement(_trackClick.Tracked, {
        event: "CLICK",
        additional: {
          context: 'LISTING_DETAILS',
          type: 'LINK',
          value: 'BACK_TO_APP_CENTER',
          v2_listing_id: ID,
          app_name: listingName,
          domain: window.location.hostname
        }
      }, _react.default.createElement("span", null, _react.default.createElement(_reactRouter.Link, {
        to: (0, _utils.getAppCenterPathName)(this.props.location.pathname),
        onClick: function onClick() {
          return document.title = _this3.props.context.getTitle(_utils.HOME);
        }
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "BackToAppCenter"
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          listing = _this$props.listing,
          _this$props$offerings = _this$props.offerings,
          offerings = _this$props$offerings === void 0 ? [] : _this$props$offerings;
      var ID = listing.ID,
          _listing$core = listing.core,
          listingDisabled = _listing$core.listingDisabled,
          regions = _listing$core.regions,
          listingName = _listing$core.listingName,
          oAuthWorkflowType = _listing$core.oAuthWorkflowType,
          clientOptInType = _listing$core.clientOptInType,
          v1ID = _listing$core.v1ID,
          _listing$core$offerin = _listing$core.offerings,
          listingOfferings = _listing$core$offerin === void 0 ? [] : _listing$core$offerin;
      var userId = this.props.userPrefs.userId;
      var hasOfferings = !userId || userId && offerings.filter(function (offering) {
        return listingOfferings.indexOf(offering) !== -1;
      }).length > 0;
      var isAdminListing = clientOptInType === 'ADMIN';

      var areRegionsPopulated = function areRegionsPopulated() {
        if (regions.asia.length > 0 || regions.emea.length > 0 || regions.latinAmerica.length > 0 || regions.northAmerica.length > 0) {
          return true;
        }

        return false;
      };

      return _react.default.createElement("div", {
        className: "details-container"
      }, _react.default.createElement(_EnrollModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement(_UnenrollModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement(_DisconnectModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement(_ConfirmationModal.default, {
        listingId: ID,
        v1ListingId: v1ID
      }), _react.default.createElement("div", {
        className: "row standard-font"
      }, _react.default.createElement("div", {
        className: "col-xs-12"
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12 back-link-row"
      }, this.renderBackToAppCenter(ID, listingName), this.renderDisabledWarning(listingDisabled, hasOfferings, isAdminListing))), _react.default.createElement(_LogoLinksAndDesc.default, {
        listing: listing,
        toggleDetails: this._toggleDetails,
        detailsExpanded: this.state.detailsExpanded,
        listingDisabled: listingDisabled || !hasOfferings && !isAdminListing
      })), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-md-12 details-lower-row"
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-12 margin-top-lg"
      }, this.props.listing.core.webScreenshots && this.props.listing.core.webScreenshots.length ? _react.default.createElement(_Carousel.default, {
        images: this.props.listing.core.webScreenshots
      }) : null)), listing.core && listing.core.offerings.length > 0 && _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-6 margin-top-lg"
      }, _react.default.createElement("h4", {
        id: "ac-offerings"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "WorksWithTheseConcurOfferings"
      })), listing.core && this.renderOfferings(listing.core.offerings))), listing.core && areRegionsPopulated() && _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-6 margin-top-lg",
        style: {
          marginBottom: !userId && '16px'
        }
      }, _react.default.createElement("h4", {
        id: "ac-listing-regions"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "RegionsAvailable"
      })), listing.core && regions && this.renderRegions(regions))), userId && _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-xs-6 margin-top-lg"
      }, _react.default.createElement("h4", null, _react.default.createElement("a", {
        href: "#",
        className: "ac-details-link",
        id: "ac-terms-link",
        onClick: this.launchTandCinfoOnly
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "TermsTitle"
      }))), (0, _utils.canUseDOM)() ? _react.default.createElement(_terms.default, {
        listingId: ID,
        v1ListingId: v1ID,
        publisher: this.props.listing.localized.publisher,
        partnerAppScopes: this.props.listing.core.partnerAppScopes,
        flow: oAuthWorkflowType,
        clientOptInType: this.props.listing.core.clientOptInType
      }) : ''))))));
    }
  }]);

  return ListingDetails;
}(_react.default.Component);

exports.ListingDetails = ListingDetails;
ListingDetails.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1Data: _propTypes.default.object
  }).isRequired,
  localizedRegions: _propTypes.default.array,
  localizedCountries: _propTypes.default.array,
  enroll: _propTypes.default.func,
  toggleTaCModal: _propTypes.default.func,
  launchTaCModal: _propTypes.default.func,
  isTaCModalOpen: _propTypes.default.bool,
  updateTermsStatus: _propTypes.default.func,
  postTerms: _propTypes.default.func,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object
  }).isRequired,
  userPrefs: _propTypes.default.shape({
    userId: _propTypes.default.string
  }),
  location: _propTypes.default.object
};

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)((0, _reactRedux.connect)(null, {
  launchTaCModal: _termsModule.launchTaCModal,
  toggleTaCModal: _termsModule.toggleTaCModal,
  postTerms: _termsModule.postTerms,
  updateTermsStatus: _termsModule.updateTermsStatus
})(ListingDetails)));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ListingDetails.js
// module id = 254
// module chunks = 0